module.exports = __webpack_public_path__ + "static/media/review-3.9198b8ff.png";